import { useAppStore, useAuthStore } from '@/stores';
import { cn } from '@/utils';
import { Layout } from 'antd';
import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';

const { Content } = Layout;

const MainLayout: React.FC = () => {
  const { sidebarCollapsed } = useAppStore();
  const location = useLocation();

  useEffect(() => {
    const checkAuth = useAuthStore.getState().checkAuth;
    checkAuth().catch(error => {
      console.error('Failed to check auth:', error);
    });
  }, [location.pathname]);

  return (
    <Layout className="min-h-screen">
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content Area */}
      <Layout
        className={cn('transition-all duration-300', sidebarCollapsed ? 'ml-[80px]' : 'ml-[300px]')}
      >
        {/* Header */}
        <Header />

        {/* Content */}
        <Content className="mt-16 p-6 bg-[#F5F7FA] min-h-[calc(100vh-64px)]">
          <div className="min-h-full">
            <Outlet />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default MainLayout;
